module.exports = __webpack_public_path__ + "static/media/Maf_JusticiaSocial_Home.2e1a2afe.jpg";